import { render, staticRenderFns } from "./TheSelect.vue?vue&type=template&id=947bce36&scoped=true"
import script from "./TheSelect.vue?vue&type=script&lang=ts"
export * from "./TheSelect.vue?vue&type=script&lang=ts"
import style0 from "./TheSelect.vue?vue&type=style&index=0&id=947bce36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947bce36",
  null
  
)

export default component.exports